import { toAbsoluteUrl } from './AssetsHelpers';

export const STATES_DATA = {
  confirmed: {
    translationKey: 'payments.statusDescriptions.completed',
    color: '#8B54F7',
    iconSrc: toAbsoluteUrl('/assets/icons/status/completed.svg'),
  },
  pending: {
    translationKey: 'payments.statusDescriptions.pending',
    color: '#F7AA4E',
    iconSrc: toAbsoluteUrl('/assets/icons/status/pending.svg'),
  },
  cancel: {
    translationKey: 'payments.statusDescriptions.rejected',
    color: '#F75454',
    iconSrc: toAbsoluteUrl('/assets/icons/status/reject.svg'),
  },
};

export const getStatePaymentData = (state) =>
  STATES_DATA[state] ?? STATES_DATA.pending;

export const getStatePaymentTranslationKey = (state) => {
  const currentData = getStatePaymentData(state);

  return currentData.translationKey;
};

export const parseResponsePayments = (response) => {
  const data = response.data.map((item) => ({
    ...item,
    metadata: JSON.parse(item.metadata),
  }));

  return { ...response, data };
};
